// extracted by mini-css-extract-plugin
export default {"container":"ReviewComplain_container__IO4Yf","content":"ReviewComplain_content__R5Wdz"};